<template>
    <div>
        <section class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6">
                        <h3>{{ $t('label.application') }}</h3>
                    </div>
                    <div class="col-md-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
                            <li class="breadcrumb-item"><router-link to="/application">{{ $t("label.application")}}</router-link></li>
                            <li class="breadcrumb-item active">{{ $t("label.edit")}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <!-- Start workflow progress -->
                    <div v-if="isOwner" class="col-md-12 col-sm-12">
                        <div class="callout callout-success">
                            <br>
                            <workflow-process />
                        </div>
                    </div>
                    <!-- End //-->

                    <div class="col-md-12 col-sm-12">
                        <!-- Start customs registration -->
                        <div class="card card-default" v-if="declaration.registration_type">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'door-open']"></fa>{{ $t("label.customs_registration") }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.customs ? $t('label.expand') : $t('label.collapse')" @click="collapse.customs = !collapse.customs">
                                        <fa :icon="collapse.customs ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								              </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{$t('label.register_type')}} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <select name="register_type" class="form-control" v-model="declaration.registration_type" disabled readonly tabindex="-1">
                                            <option value="IM">{{$t('label.temporary_import')}}</option>
                                            <option value="EX">{{$t('label.temporary_export')}}</option>
                                        </select>
                                        <span v-if="errors.has('register_type')" class="text-danger">
                                            {{ errors.first('register_type') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="registration_number" class="col-md-4 col-form-label">{{$t('label.register_number')}} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" id="registration_number" class="form-control" :placeholder="$t('label.register_number')" :value="declaration.registration_year + ' ' + declaration.registration_serial + ' ' + declaration.registration_number" disabled readonly tabindex="-1" />
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ declaration.registration_type!=='EX' ? $t('label.entry_office_name') : $t('label.exit_office_name')}}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.lodgement_office_name" class="form-control" :placeholder="$t('label.exit_office_name')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label required">{{ declaration.registration_type!=='EX' ? $t('label.entry_date') : $t('label.exit_date')}}</label>
                                    <div class="col-md-8">
                                        <datepicker
                                        :disabled="isLodgementAssessedApprove"
                                        v-model="declaration.lodgement_office_date"
                                        v-validate="'required'"
                                        :name="declaration.registration_type!=='EX' ? 'entry_date' : 'exit_date'"
                                        :id="declaration.registration_type!=='EX' ? 'entry_date' : 'exit_date'" 
                                        v-on:selected="changeEntryDate" 
                                        :bootstrapStyling="true" 
                                        :clearButton="declaration.lodgement == null"
                                        :highlighted="highlightedCurrentDate" 
                                        :language="lang" 
                                        input-class="form-control form-control-datepicker" 
                                        format="dd/MM/yyyy" 
                                        :placeholder="'DD/MM/YYYY'" 
                                        :disabledDates="{ to: new Date(Date.now()-24*60*60*1000) }"></datepicker>
                                        <span v-if="errors.has('entry_date')" class="text-danger">
                                            {{ errors.first('entry_date') }}
                                        </span>
                                        <span v-if="errors.has('exit_date')" class="text-danger">
                                            {{ errors.first('exit_date') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="destination_office" class="col-md-4 col-form-label required">{{declaration.registration_type==='EX' ? $t('label.entry_office_name') : $t('label.exit_office_name')}}</label>
                                    <div class="col-md-8">
                                        <v-select
                                                v-model="declaration.destination_office_name"
                                                v-validate="'required'"
                                                :name="declaration.registration_type==='EX' ? 'destination_entry_office_name' : 'destination_exit_office_name'"
                                                id="destination_office"
                                                label="full_name"
                                                :options="officeNames">
                                        </v-select>
                                        <span v-if="errors.has('destination_entry_office_name')" class="text-danger">
                                            {{ errors.first('destination_entry_office_name') }}
                                        </span>
                                        <span v-if="errors.has('destination_exit_office_name')" class="text-danger">
                                            {{ errors.first('destination_exit_office_name') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label required">{{ declaration.registration_type==='EX' ? $t('label.entry_date') : $t('label.exit_date')}}</label>
                                    <div class="col-md-8">
                                        <datepicker 
                                        :name="declaration.registration_type==='EX' ? 'destination_entry_date' : 'destination_exit_date'" 
                                        :id="declaration.registration_type==='EX' ? 'destination_entry_date' : 'destination_exit_date'" 
                                        v-validate="'required'" 
                                        v-on:selected="changeExitDate" :disabledDates="{ to: new Date(declaration.lodgement_office_date), from: new Date(allow_max_period) }"
                                        :bootstrapStyling="true" 
                                        :clearButton="true" 
                                        :highlighted="highlightedCurrentDate" 
                                        :language="lang" 
                                        input-class="form-control form-control-datepicker" 
                                        format="dd/MM/yyyy" 
                                        :placeholder="'DD/MM/YYYY'" 
                                        v-model="declaration.destination_office_date">
                                        </datepicker>
                                        <span v-if="errors.has('destination_entry_date')" class="text-danger">
                                            {{ errors.first('destination_entry_date') }}
                                        </span>
                                        <span v-if="errors.has('destination_exit_date')" class="text-danger">
                                            {{ errors.first('destination_exit_date') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End //-->

                        <!-- Start Owner information -->
                        <div class="card card-default" v-if="declaration.owner && declaration.owner.first_name">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'user']"></fa> {{ $t('label.owner_information') }} <span class="text-danger"> * </span></h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.owner ? $t('label.expand') : $t('label.collapse')" @click="collapse.owner = !collapse.owner">
                                        <fa :icon="collapse.owner ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.first_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" :placeholder="$t('label.first_name')" v-model="declaration.owner.first_name" disabled readonly tabindex="-1"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.last_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" :placeholder="$t('label.last_name')" v-model="declaration.owner.last_name" disabled readonly tabindex="-1"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.nationality') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" :placeholder="$t('label.nationality')" v-model="declaration.owner.nationality" disabled readonly tabindex="-1"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.gender') }}</label>
                                    <div class="col-md-8">
                                        <select class="form-control" v-model="declaration.owner.gender" disabled readonly tabindex="-1">
                                            <option value="m">{{ $t('label.male') }}</option>
                                            <option value="f">{{ $t('label.female') }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" :placeholder="$t('label.passport_number')" v-model="declaration.owner.passport_number" disabled readonly tabindex="-1"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_issued_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.owner.passport_issued_date" :bootstrap-styling="true" :disabled="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly"></datepicker>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_expired_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.owner.passport_expired_date" :bootstrap-styling="true" :disabled="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly"></datepicker>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="owner_border_pass_number" class="col-md-4 col-form-label">{{ $t('label.border_pass_number') }}</label>
                                    <div class="col-md-8">
                                        <!-- <input v-validate="{required : declaration.owner.passport_number === '' || declaration.owner.passport_number === null}" name="border_pass_number" id="owner_border_pass_number" type="text" class="form-control" :placeholder="$t('label.border_pass_number')" v-model="declaration.owner.border_pass_number"/>-->
                                        <input v-validate="{required : false}" name="border_pass_number" id="owner_border_pass_number" type="text" class="form-control" :placeholder="$t('label.border_pass_number')" v-model="declaration.owner.border_pass_number"/>
                                        <span v-if="errors.has('border_pass_number')" class="text-danger">
                                            {{ errors.first('border_pass_number') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.border_pass_date') }}</label>
                                    <div class="col-md-8">
                                        <!-- <datepicker v-model="declaration.owner.border_pass_date" v-validate="{ required : declaration.owner.passport_number === '' || declaration.owner.passport_number === null}" name="border_pass_date"  :bootstrap-styling="true" :clear-button="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>-->
                                        <datepicker v-model="declaration.owner.border_pass_date" v-validate="{ required : false}" name="border_pass_date"  :bootstrap-styling="true" :clear-button="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
                                        <span v-if="errors.has('border_pass_date')" class="text-danger">
                                            {{ errors.first('border_pass_date') }}
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.owner.identity_card_number" class="form-control" :placeholder="$t('label.identity_number')" readonly disabled tabindex="-1"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.owner.identity_card_issued_date" :bootstrap-styling="true" :disabled="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly"></datepicker>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_card_expired_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.owner.identity_card_expired_date" :bootstrap-styling="true" :disabled="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker readonly"></datepicker>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="owner_address_in_cambodia" class="col-md-4 col-lg-4 col-form-label">{{ $t('label.address_in_cambodia') }}</label>
                                    <div class="col-md-8 col-lg-8">
                                        <input name="owner_address_in_cambodia" id="owner_address_in_cambodia" type="text" class="form-control" :placeholder="$t('label.address_in_cambodia')" v-model="declaration.owner.address" readonly disabled tabindex="-1"/>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.length_of_stay') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" :placeholder="$t('label.length_of_stay')" v-model="declaration.owner.inbound_stay" readonly disabled tabindex="-1"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Vehicle information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'car']"></fa> {{ $t('label.vehicle_information') }}</h3>
                                <div class="card-tools">
                                    <!--
                                    <button v-if="!isLodgementAssessedApprove && isOwner" type="button" class="btn btn-tool text-primary" @click="vehicleList">
                                        {{ $t('label.choose_vehicle') }}
                                        <fa :icon="fas.faCarAlt" class="ml-1"/>
                                    </button>
                                    -->
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.vehicle ? $t('label.expand') : $t('label.collapse')" @click="collapse.vehicle = !collapse.vehicle">
                                        <fa :icon="collapse.vehicle ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body mb-0" v-if="declaration.vehicles.length > 0">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.plate_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].plate_number" class="form-control" :placeholder="$t('label.plate_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.nationality') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].nationality" class="form-control" :placeholder="$t('label.nationality')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.brand') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].brand" class="form-control" :placeholder="$t('label.brand')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.color') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].color" class="form-control" :placeholder="$t('label.color')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.frame_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].frame_number" class="form-control frame_number" :placeholder="$t('label.frame_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.engine_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.vehicles[0].engine_number" class="form-control engine_number" :placeholder="$t('label.engine_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.year') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="number" v-model="declaration.vehicles[0].year" class="form-control" :placeholder="$t('label.year')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div style="text-align:right;">
                                  <a href="#"  @click.prevent="viewVehicleDetail" :title="isEditable ? $t('label.edit_detail') : $t('label.view_detail')">
                                    {{ isEditable ? $t('label.edit_detail') : $t('label.view_detail') }}
                                  </a>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Driver information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'users']"></fa> {{ $t('label.driver_information') }}</h3>
                                <div class="card-tools">
                                    <!--
                                    <button v-if="!isLodgementAssessedApprove && isOwner" type="button" class="btn btn-tool text-primary" @click="driverList">
                                        {{ $t('label.choose_driver') }}
                                        <fa :icon="fas.faUser" class="ml-1"/>
                                    </button>
                                    -->
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.driver ? $t('label.expand') : $t('label.collapse')" @click="collapse.driver = !collapse.driver">
                                        <fa :icon="collapse.driver ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body mb-0" v-if="declaration.drivers.length > 0">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.last_name') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.drivers[0].last_name" class="form-control" :placeholder="$t('label.last_name')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.first_name') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.drivers[0].first_name" class="form-control" :placeholder="$t('label.first_name')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.gender') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-if="declaration.drivers[0].gender == 'f'" value="Female" class="form-control" :placeholder="$t('label.gender')" readonly disabled tabindex="-1" />
                                        <input type="text" v-else value="Male" class="form-control" :placeholder="$t('label.gender')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.nationality') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.drivers[0].nationality" class="form-control" :placeholder="$t('label.nationality')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.drivers[0].identity_card_number" class="form-control" :placeholder="$t('label.identity_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_date') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                      <datepicker v-model="declaration.drivers[0].identity_card_issued_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.identity_card_expired_date') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                      <datepicker v-model="declaration.drivers[0].identity_card_expired_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.drivers[0].passport_number" class="form-control" :placeholder="$t('label.passport_number')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_issued_date') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                      <datepicker v-model="declaration.drivers[0].passport_issued_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.passport_expired_date') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                      <datepicker v-model="declaration.drivers[0].passport_expired_date" :bootstrap-styling="true" :clear-button="false" :highlighted="highlightedCurrentDate" :language="lang" :disabled="true" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker"></datepicker>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.border_pass_number') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.drivers[0].border_pass_number" v-validate="{required : !declaration.drivers[0].passport_number && !declaration.drivers[0].passport_issued_date && !declaration.drivers[0].passport_expired_date}" name="driver_border_pass_number" class="form-control" :placeholder="$t('label.border_pass_number')"/>
                                        <span v-if="errors.has('driver_border_pass_number')" class="text-danger">
                                            {{ errors.first('driver_border_pass_number') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.border_pass_date') }} <span class="text-danger"> * </span></label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.drivers[0].border_pass_date" v-validate="{required : !declaration.drivers[0].passport_number && !declaration.drivers[0].passport_issued_date && !declaration.drivers[0].passport_expired_date}" name="driver_border_pass_date" :bootstrap-styling="true" :clear-button="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker can-editable"></datepicker>
                                        <span v-if="errors.has('driver_border_pass_date')" class="text-danger">
                                            {{ errors.first('driver_border_pass_date') }}
                                        </span>
                                    </div>
                                </div>
                                <div style="text-align:right;">
                                  <a href="#" type="button" @click.prevent="viewDriverDetail" :title="isEditable ? $t('label.edit_detail') : $t('label.view_detail')">
                                    {{ isEditable ? $t('label.edit_detail') : $t('label.view_detail') }}
                                  </a>
                                </div>
                            </div>
                        </div>
                        <!-- End -->

                        <!-- Start Company information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'hotel']"></fa> {{ $t('label.company_information') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.company ? $t('label.expand') : $t('label.collapse')" @click="collapse.company = !collapse.company">
                                        <fa :icon="collapse.company ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="company_code" class="col-md-4 col-form-label">{{ $t('label.company_code') }}</label>
                                    <div class="col-md-8">
                                        <input v-model="declaration.company_code" type="text" id="company_code" class="form-control" :placeholder="$t('label.company_code')" @blur="getCompany" @keydown="companyCodeKeyDown"/>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="company_name" class="col-md-4 col-form-label">{{ $t('label.company_name') }}</label>
                                    <div class="col-md-8">
                                        <input v-model="declaration.company_name" type="text" id="company_name" class="form-control" :placeholder="$t('label.company_name')" readonly disabled tabindex="-1"/>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.company_address') }}</label>
                                    <div class="col-md-8">
                                        <textarea v-model="declaration.company_address" class="form-control" :placeholder="$t('label.company_address')" readonly disabled tabindex="-1" rows="3"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Guarantee information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'money-check-alt']"></fa> {{ $t('label.guarantee_information') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.guarantee ? $t('label.expand') : $t('label.collapse')" @click="collapse.guarantee = !collapse.guarantee">
                                        <fa :icon="collapse.guarantee ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="security_office" class="col-md-4 col-form-label">{{ $t('label.office')}}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_office" v-validate="{ required: declaration.security_serial != null && declaration.security_serial != '' }" name="security_office" id="security_office" class="form-control" :class="security_errors.security_office ? 'error-border' : ''" :placeholder="$t('label.office')" @blur="getSecurityAmount" />
                                        <span v-if="errors.has('security_office')" class="text-danger">{{ errors.first('security_office') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="security_serial" class="col-md-4 col-form-label">{{ $t('label.serial') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_serial" v-validate="{ required: declaration.security_number != null && declaration.security_number != '' }" name="security_serial" id="security_serial" class="form-control" :class="security_errors.security_serial ? 'error-border' : ''" :placeholder="$t('label.serial')" @blur="getSecurityAmount" />
                                        <span v-if="errors.has('security_serial')" class="text-danger">{{ errors.first('security_serial') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="security_number" class="col-md-4 col-form-label">{{ $t('label.receipt_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_number"  v-validate="{ required: declaration.security_date != null && declaration.security_date != '' }" name="security_number" id="security_number" class="form-control" :class="security_errors.security_number ? 'error-border' : ''" :placeholder="$t('label.receipt_number')" @blur="getSecurityAmount" />
                                        <span v-if="errors.has('security_number')" class="text-danger">{{ errors.first('security_number') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.security_date"  v-validate="{ required: declaration.security_office != null && declaration.security_office != '' }" name="security_date" :class="security_errors.security_date ? 'error-border' : ''" :bootstrap-styling="true" :clear-button="true" :highlighted="highlightedCurrentDate" :language="lang" format="dd/MM/yyyy" placeholder="DD/MM/YYYY" input-class="form-control form-control-datepicker" @input="getSecurityAmount"></datepicker>
                                        <span v-if="errors.has('security_date')" class="text-danger">{{ errors.first('security_date') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="security_amount" class="col-md-4 col-form-label">{{ $t('label.amount') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_amount" id="security_amount" class="form-control" :placeholder="$t('label.amount')" readonly disabled tabindex="-1" />
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.currency')}}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.security_currency" class="form-control" :placeholder="$t('label.currency')" readonly disabled tabindex="-1">
                                    </div>
                                </div>

                                <div class="mb-0" v-if="amount_is_returned">
                                    <br>
                                    <div class="alert alert-danger mb-0" role="alert">
                                        {{$t('label.security_returned')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Other information -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'shield-alt']"></fa> {{ $t('label.other_information') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.other ? $t('label.expand') : $t('label.collapse')" @click="collapse.other = !collapse.other">
                                        <fa :icon="collapse.other ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label for="insurance_company_code" class="col-md-4 col-form-label">{{ $t('label.insurance_company_code') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.insurance_company_code" v-validate="{ required: declaration.insurance_company_name != null && declaration.insurance_company_name != ''}" name="insurance_company_code" id="insurance_company_code" class="form-control" :placeholder="$t('label.insurance_company_code')" @blur="getInsurance" />
                                        <span v-if="errors.has('insurance_company_code')" class="text-danger">{{ errors.first('insurance_company_code') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="insurance_company_name" class="col-md-4 col-form-label">{{ $t('label.insurance_company_name') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.insurance_company_name" v-validate="{ required: declaration.insurance_number != null && declaration.insurance_number != ''}" name="insurance_company_name" id="insurance_company_name" class="form-control" :placeholder="$t('label.insurance_company_name')" />
                                        <span v-if="errors.has('insurance_company_name')" class="text-danger">{{ errors.first('insurance_company_name') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="insurance_number" class="col-md-4 col-form-label">{{ $t('label.insurance_number') }}</label>
                                    <div class="col-md-8">
                                        <input type="text" v-model="declaration.insurance_number" v-validate="{ required: declaration.insurance_date != null && declaration.insurance_date != '' }" name="insurance_number" id="insurance_number" class="form-control" :placeholder="$t('label.insurance_number')" />
                                        <span v-if="errors.has('insurance_number')" class="text-danger">{{ errors.first('insurance_number') }}</span>
                                    </div>
                                </div>

                                <div class="form-group row mb-0">
                                    <label class="col-md-4 col-form-label">{{ $t('label.insurance_date') }}</label>
                                    <div class="col-md-8">
                                        <datepicker v-model="declaration.insurance_date" v-validate="{ required: declaration.insurance_company_code != null && declaration.insurance_company_code != '' }" name="insurance_date" :bootstrapStyling="true" :clear-button="true" :highlighted="highlightedCurrentDate" :language="lang" :disabled="false" input-class="form-control form-control-datepicker"  format="dd/MM/yyyy" :placeholder="'DD/MM/YYYY'"></datepicker>
                                        <span v-if="errors.has('insurance_date')" class="text-danger">{{ errors.first('insurance_date') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End // -->

                        <!-- Start Attachment file -->
                        <div class="card card-default">
                            <div class="card-header">
                                <h3 class="card-title custom-card-title"><fa :icon="['fas', 'paperclip']"></fa> {{ $t('label.attachment') }}</h3>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-widget="collapse" :title="collapse.attachment ? $t('label.expand') : $t('label.collapse')" @click="collapse.attachment = !collapse.attachment">
                                        <fa :icon="collapse.attachment ? fas.faAngleLeft : fas.faAngleDown" style="font-size: 20px"/>
                                    </button>
								                </div>
                            </div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-md-4 col-form-label">{{ $t('label.other') }}</label>
                                    <div class="col-md-8">
                                        <table class="table" v-if="files.length > 0">
                                            <tbody>
                                                <tr v-if="files.length" class="table-borderless">
                                                    <th>{{ $t('label.name') }}</th>
                                                    <th width="50px">{{ $t('label.delete') }}</th>
                                                </tr>
                                                <tr v-for="(file, index) in files" :key="index">
                                                    <td>
                                                        <span class="text-success cursor-pointer" @click="showImage(file)"
                                                        >{{ file.name.substring(file.name.length - 40 , file.name.length) }}
                                                        </span>
                                                    </td>
                                                    <td class="text-right">
                                                        <span class="btn btn-sm btn-link" @click="removeFile(index, file)"><fa :icon="fas.faTimesCircle" class="text-danger"/></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="row">
                                            <div class="col-md-6 col-12">
                                                <a class="btn btn-sm btn-secondary" href="#" @click.prevent="$refs.attachment.click()">
                                                    <fa :icon="['fas', 'paperclip']"></fa>
                                                    {{$t('label.choose_document')}}
                                                </a>
                                                <input type="file" class="d-none" ref="attachment" name="attachment" id="attachment" accept="image/x-png,image/jpeg,image/jpeg,application/pdf" multiple @change="handleFilesUpload">
                                            </div>
                                            <span class="text-muted ml-2 mt-2">{{ $t('label.other_file_criteria')}}</span>
                                        </div>

                                    </div>
                                </div>
                                <input v-if="$hasPermission('tempvehicle.application.edit') && canUpdate" type="button" class="btn btn-primary float-right" @click.prevent="update" :value="$t('label.save')">
                            </div>
                        </div>
                        <!-- End // -->
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { fas } from "@fortawesome/free-solid-svg-icons";
    import {mapState} from "vuex";
    const moment = require('moment');
    export default {
        name: 'EditApplication',
        computed: {
            fas() {
                return fas;
            },
            driverNames(){
                return this.drivers.map(function(driver) {
                    return driver.first_name + ' ' + driver.last_name;
                });
            },
            countryNames() {
                return this.countries.map(function(country) {
                    return country.name;
                });
            },
            officeNames() {
                return this.offices.map(function(office) {
                    return office.code + " - " + office.name;
                });
            },
            unSelectedDrivers(){
                return this.drivers.filter(driver => {
                    let bool = true;
                    this.declaration.drivers.forEach(d => {
                        if(typeof d !== 'undefined' && d != null && d.first_name == driver.first_name && d.last_name == driver.last_name && d.identity_card_number == driver.identity_card_number){
                            bool = false;
                        }
                    });
                    return bool;
                });
            },
            isLodgementAssessedApprove(){
              let lodgement = this.declaration.lodgement;
              if(!lodgement) return false;
              let status = lodgement.status || "";
              return status.toLowerCase() === "approve";
            },
            ...mapState("user", ["user"]),
            isOwner(){
              if(this.user && this.declaration.user_id){
                return this.declaration.user_id === this.user.data.id;
              }
              return false;
            },
            isEditable(){
              return this.$route.name === 'EditApplication' && !this.isLodgementAssessedApprove;
            },
            canUpdate(){
              if(this.isLodgementAssessedApprove) {
                return this.user.data.is_officer;
              }
              return true;
            },
            offices(){
              return this.$store.getters['reference/offices'];
            },
            countries(){
              return this.$store.getters['reference/countries'];
            },
            drivers(){
              return this.$store.getters['application/driversData'];
            },
            allow_max_period_backup(){
              if(this.declaration.lodgement_office_date){
                this.days(); // Calculate length of stay
                return Math.floor(Math.abs((new Date(this.declaration.lodgement_office_date).getTime()+parseInt(this.MAX_PERIOD)*24*60*60*1000))-1);
              }
              return Math.floor(Math.abs((new Date().getTime()+parseInt(this.MAX_PERIOD)*24*60*60*1000))-1);
            },
            allow_max_period() {
              let selected_max_period = (this.declaration.registration_type === "IM") ? this.MAX_PERIOD : this.MAX_EXIT_PERIOD;
              let startDate = new Date();
              if(this.declaration.lodgement_office_date){
                this.days(); // Calculate length of stay
                startDate = new Date(this.declaration.lodgement_office_date);
              }

              const maxDate = new Date(startDate);
              maxDate.setDate(maxDate.getDate() + parseInt(selected_max_period));
              return maxDate;
            },
        },
        mounted() {
            //this.getOffices();
            //this.getDrivers();
            //this.getCurrencies();
            //this.getCountries();
            this.uuid = this.$route.params.uuid;
            this.imageBaseUrl = process.env.VUE_APP_BACKEND_API_URL + '/';
            this.display();
            this.MAX_PERIOD = process.env.VUE_APP_MAX_PERIOD || 30;
            $('[data-toggle="tooltip"]').tooltip();
            this.MAX_EXIT_PERIOD = process.env.VUE_APP_MAX_EXIT_PERIOD || 365;
        },
        updated() {
            //this.days();
            $("body .readonly").removeAttr("style");
            $("body .can-editable").css("background-color", "white");
            $(".modal").on('shown.bs.modal', function (e) {
                $("body").css("overflow", "hidden");
            });
            $(".modal").on('hidden.bs.modal', function (e) {
                $("body").css("overflow", "initial");
            });
        },
        data() {
            return {
                baseURI: "",
                //offices: [],
                //currencies: [],
                companies: [],
                //drivers: [],
                owner: [],
                //countries: [],
                vehicle: {},
                uuid: '',
                declaration: {
                    uuid: '',
                    registration_type: '',
                    registration_number: '',
                    lodgement_office_code: '',
                    lodgement_office_name: '',
                    lodgement_office_date: '',
                    destination_office_code: '',
                    destination_office_name: '',
                    destination_office_date: '',
                    company_code: '',
                    company_name: '',
                    company_address: '',
                    is_owner: true,
                    owner: {
                        address: '',
                        border_pass_number: '',
                        border_pass_date: '',
                        first_name: '',
                        full_name: '',
                        gender: '',
                        last_name: '',
                        nationality: '',
                        nationality_code: '',
                        inbound_stay: 0,

                        passport_number: '',
                        passport_issued_date: '',
                        passport_expired_date: '',

                        identity_card_number: '',
                        identity_card_issued_date: '',
                        identity_card_expired_date: '',
                    },                    
                    security_office: '',
                    security_serial: '',
                    security_number: '',
                    security_date: '',
                    security_amount: '',
                    security_currency: '',
                    insurance_company_code: '',
                    insurance_company_name: '',
                    insurance_number: '',
                    insurance_date: '',
                    vehicles: [],
                    drivers: []
                },

                lodgement_office: '',
                destination_office: '',
                security_office: '',
                security_errors: {
                    security_serial: false,
                    security_office: false,
                    security_number: false,
                    security_date: false
                },
                amount_is_returned: false,
                max_period: 0,
                MAX_PERIOD: 0,
                MAX_EXIT_PERIOD: 0,

                files: [],
                files_delete: [],
                imageBaseUrl: '',
                collapse:{
                    customs: false,
                    owner: false,
                    vehicle: false,
                    driver: false,
                    company: false,
                    guarantee: false,
                    other: false,
                    attachment: false,
                }
            }
        },
        watch: {
            "declaration.vehicles": function (val, old) {
                val.forEach(function (item, index) {
                    if(typeof item.driver === 'undefined'){
                        item.driver = null;
                    }
                })
            },
            "declaration.destination_office_name": function(val){
                if(val === '' || val == null){
                    this.declaration.destination_office_code = '';
                }else{
                    if(val !== '' && val != null && this.offices.length > 0 && typeof this.declaration.destination_office_code != 'undefined' && this.declaration.destination_office_code != null){
                       let destination_office = this.offices.filter(function(office){
                           return (office.code + " - " + office.name) === val;
                       })[0];
                       if(typeof destination_office !== 'undefined'){
                           this.declaration.destination_office_code = destination_office.code;
                           this.declaration.destination_office_name = destination_office.name;
                       }
                    }
                }
            },
            security_office: function (val) {
                if(val != null) {
                    this.declaration.security_office = val.code;
                }
            }
        },
        methods: {
            validate() {
                this.$validator.validateAll();
                return this.errors.any();
            },
            vehicleList() {
                $("#vehicleList").modal("show");
            },
            driverList() {
                $("#driverList").modal("show");
            },
            getOffices() {
                this.$store.state.loading.status = true;
                let url = this.baseURI+'/reference/offices';
                GDCE_Client.requestApi("GET", url).then(response => {
                    let offices = [];
                    response.data.forEach(function(office) {
                        offices.push({name: office.name, code: office.code, full_name: office.code + " - " + office.name});
                    });
                    this.offices = offices;
                    this.$store.state.loading.status = false;
                });
            },
            viewOwnerDetail() {
              let suffix = this.isEditable ? '/owner/edit/':'/owner/';
              window.open(suffix + this.declaration.owner.owner_id, '_blank');
            },
            viewDriverDetail() {
                if(this.declaration.drivers[0].uuid){
                  let suffix = this.isEditable ? '/driver/edit/':'/driver/';
                  window.open(suffix + this.declaration.drivers[0].uuid, '_blank');
                }
            },
            viewVehicleDetail() {
                if(this.declaration.vehicles[0].uuid){
                  let suffix = this.isEditable ? '/vehicle/edit/':'/vehicle/';
                  window.open(suffix + this.declaration.vehicles[0].uuid, '_blank');
                }
            },
            getCompany() {
                if(this.declaration.company_code) {
                  if (this.declaration.company_code.trim() !== '') {
                    this.$store.state.loading.status = true;
                    let url = this.baseURI + 'reference/company/' + this.declaration.company_code;
                    let address = "";
                    GDCE_Client.requestApi("GET", url).then(response => {
                      this.declaration.company_name = response.data.name;
                      if (response.data.address1)
                        address = response.data.address1;
                      if (response.data.address2)
                        address += " " + response.data.address2;
                      if (response.data.address3)
                        address += " " + response.data.address3;
                      if (response.data.address4)
                        address += " " + response.data.address4;
                      this.declaration.company_address = address.trim();
                      this.$store.state.loading.status = false;
                    }).catch(error => {
                      this.$store.state.loading.status = false;
                      this.$swal({
                        title: this.$t('label.input_information_invalid'),
                        icon: "info",
                        buttons: {
                          yes: {
                            text: this.$t('label.yes'),
                            value: "Yes",
                          }
                        }
                      }).then((value) => {
                        this.declaration.company_code = "";
                        this.declaration.company_name = "";
                        this.declaration.company_address = "";
                        this.$store.state.loading.status = false;
                      });
                    });
                  }
                }
            },
            getInsurance() {
                if(this.declaration.insurance_company_code) {
                  if (this.declaration.insurance_company_code.trim() != '') {
                    this.$store.state.loading.status = true;
                    let url = this.baseURI + 'reference/company/' + this.declaration.insurance_company_code;
                    GDCE_Client.requestApi("GET", url).then(response => {
                      this.declaration.insurance_company_name = response.data.name;
                      this.declaration.insurance_number = response.data.insurance_number;
                      //this.declaration.insurance_date = new Date(response.data.valid_from);
                      this.$store.state.loading.status = false;
                    }).catch(error => {
                      this.$store.state.loading.status = false;
                      this.$swal({
                        title: this.$t('label.input_information_invalid'),
                        icon: "info",
                        buttons: {
                          yes: {
                            text: this.$t('label.yes'),
                            value: "Yes",
                          }
                        }
                      }).then((value) => {
                        this.declaration.insurance_company_code = "";
                        this.declaration.insurance_company_name = "";
                        this.declaration.insurance_number = "";
                        this.declaration.insurance_date = "";
                        this.$store.state.loading.status = false;
                      });
                    });
                  }
                }
            },
            getSecurityAmount() {
                if(this.declaration.security_office && this.declaration.security_serial
                    && this.declaration.security_number && this.declaration.security_date) {

                    this.$store.state.loading.status = true;
                    
                    let data = {
                        security_office: this.declaration.security_office,
                        security_serial: this.declaration.security_serial,
                        security_number: this.declaration.security_number,
                        security_date: this.renderDate(this.declaration.security_date)
                    };
                    let url = this.baseURI+'/reference/deposit';
                    GDCE_Client.requestApi("POST", url, data).then(response => {
                        if(response.status) {
                            this.declaration.security_amount = response.data.amount;
                            this.declaration.security_currency = response.data.currency;

                            this.security_errors.security_office = false;
                            this.security_errors.security_serial = false;
                            this.security_errors.security_number = false;
                            this.security_errors.security_date = false;

                            if(response.data.is_returned === "on")
                                this.amount_is_returned = true;
                            else
                                this.amount_is_returned = false;
                        } else {
                            this.declaration.security_amount = "";
                            this.declaration.security_currency = "";
                            this.amount_is_returned = false;
                        }
                        this.$store.state.loading.status = false;
                    }).catch(error => {
                        this.declaration.security_amount = "";
                        this.declaration.security_currency = "";

                        this.security_errors.security_office = true;
                        this.security_errors.security_serial = true;
                        this.security_errors.security_number = true;
                        this.security_errors.security_date = true;
                        this.amount_is_returned = false;
                        this.$store.state.loading.status = false;

                        this.$swal({
                            title: this.$t('label.guarantee_information_invalid'),
                            icon: "info",
                            buttons: {
                                yes: {
                                    text: this.$t('label.yes'),
                                    value: "Yes",
                                }
                            }
                        }).then((value) => {
                            this.declaration.security_office = "";
                            this.declaration.security_serial = "";
                            this.declaration.security_number = "";
                            this.declaration.security_date = "";
                            this.declaration.security_amount = "";
                            this.declaration.security_currency = "";
                            $("input[name='security_office']").focus();

                            this.security_errors.security_office = false;
                            this.security_errors.security_serial = false;
                            this.security_errors.security_number = false;
                            this.security_errors.security_date = false;
                            this.amount_is_returned = false;
                            this.$store.state.loading.status = false;
                        });
                    });
                } else {
                    this.declaration.security_amount = "";
                    this.declaration.security_currency = "";
                }
            },
            getDrivers () {
                this.$store.state.loading.status = true;
                let url = this.baseURI + 'drivers';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.drivers = response.data;
                    this.$store.state.loading.status = false;
                });
            },
            getCurrencies() {
                this.$store.state.loading.status = true;
                let url = this.baseURI+'/reference/currencies';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.currencies = response.data;
                    this.$store.state.loading.status = false;
                }).catch(error => {
                    this.$store.state.loading.status = false;
                });
            },
            getCountries() {
                this.$store.state.loading.status = true;
                let url = this.baseURI + 'reference/countries';
                GDCE_Client.requestApi("GET", url)
                    .then(response => {
                            this.countries = response.data;
                            this.$store.state.loading.status = false;
                        });
            },
            changeDriver(data, index){
                let driverIds = [];
                this.selectedDrivers = [];
                this.declaration.vehicles.forEach(function (item) {
                   if(item.driver!==null){
                       driverIds.push(item.driver.id);
                   }
                });
            },
            changeEntryDate(dateChange) {
                this.declaration.lodgement_office_date = new Date(dateChange).getTime();
                this.declaration.destination_office_date = '';
            },
            changeExitDate(dateChange) {
                this.declaration.destination_office_date = new Date(dateChange).getTime();
            },
            days_backup() {
                if(
                    (this.declaration.lodgement_office_date != "" || this.declaration.lodgement_office_date != null) &&
                    (this.declaration.destination_office_date != "" || this.declaration.destination_office_date != null))
                {
                    let oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
                    let entry_date = new Date(this.declaration.lodgement_office_date);
                    let exit_date = new Date(this.declaration.destination_office_date);
                    this.max_period = Math.floor(Math.abs((entry_date.getTime()+parseInt(this.MAX_PERIOD)*24*60*60*1000)));
                    let inbound_stay = Math.floor(Math.abs((entry_date.getTime() - exit_date.getTime())/(oneDay))+1);
                    if(!isNaN(inbound_stay)) {
                        this.declaration.owner.inbound_stay = inbound_stay;
                    }
                }
            },
            update(e) { 
                this.$validator.validate()
                    .then(result => {
                        if (!result) {
                            e.preventDefault();
                        }else{
                            this.$store.state.loading.status = true;
                            this.declaration.destination_office_date = this.$formatObjectDate(this.declaration.destination_office_date);
                            this.declaration.lodgement_office_date = this.$formatObjectDate(this.declaration.lodgement_office_date);
                            this.declaration.prepare_delete = this.files_delete;
                            let url = this.baseURI+'/applications/'+this.uuid;
                            GDCE_Client.requestApi("PATCH", url, this.declaration).then(response => {
                                if(response.status){
                                    this.uploadFile(response.data);
                                }else{
                                    this.$swal({
                                        title: this.$t('message.already_declaration'),
                                        icon: "info",
                                        text: response.message,
                                        buttons: {
                                            close: this.$t('label.close'),
                                        }
                                    })
                                }
                                this.$store.state.loading.status = false;
                            }).catch(error => {
                                console.log(error);
                                this.$store.state.loading.status = false;
                            });
                        }
                    }
                );
            },
            clearLodgmentOffice(data) {
                if(data === null) {
                    this.declaration.lodgement_office_code = "";
                    this.declaration.lodgement_office_name = "";
                }
            },
            clearDestinationOffice(data) {
                if(data === null) {
                    this.declaration.destination_office_code = "";
                    this.declaration.destination_office_name = "";
                }
            },
            clearSecurityOffice(data) {
                if(data === null) {
                    this.declaration.security_office = "";
                }
            },
            display() {
                this.$store.state.loading.status = true;
                let url = this.baseURI+'/applications/'+this.uuid;
                GDCE_Client.requestApi("GET", url)
                .then(response => {
                    if(response.status) {
                        this.files = Object.values(response.attachments);
                        this.declaration = response.data;
                    } else {
                        this.declaration = {
                            drivers: {},
                            owner: {},
                            vehicles: {}
                        }
                    }
                    this.$store.state.loading.status = false;
                })
                .catch(error => {
                    this.$store.state.loading.status = false;
                });
            },
            removeVehicle(index) {
                this.declaration.vehicles.splice(index, 1);
                this.declaration.drivers.splice(index, 1);
            },
            companyCodeKeyDown(e) {
                if(e.keyCode == 46 || e.keyCode == 8) {
                    this.declaration.company_name = "";
                    this.declaration.company_address = "";
                    this.$store.state.loading.status = false;
                } else if(e.keyCode == 13) {
                    this.getCompany();
                }
            },
            renderDate(myDate){
                return myDate.getFullYear()+'-'+(myDate.getMonth()+1)+'-'+myDate.getDate();
            },
            triggerButton(elId){
                $(elId).click();
            },
            handleFilesUpload(){
                let uploadedFiles = this.$refs.attachment.files;
                for( var i = 0; i < uploadedFiles.length; i++ ){
                    if(this.hasExtension(uploadedFiles[i].name, ['.jpeg','.png','.jpg','.pdf'])){
                        if(uploadedFiles[i].size < (1024 * 1024) * 10){
                            this.files.push( uploadedFiles[i] );
                        }
                    }
                }
            },
            hasExtension(file_name, exts) {
                var extention = file_name.substring(file_name.length - 4,file_name.length);
                for(var i = 0; i < exts.length; i++){
                    if(extention === exts[i]){
                        return true;
                    }
                }
            },
            removeFile(key,file){
                this.prepareDelete(file);
                this.files.splice(key,1);
            },
            prepareDelete(file){
              if(!(file instanceof File)){
                this.files_delete.push(file.name);
              }
            },
            uploadFile(uuid){
                if(this.files.length > 0){
                    let formData = new FormData();
                    for( var i = 0; i < this.files.length; i++ ){
                        if(Object.prototype.toString.call(this.files[i]) != '[object Object]'){
                            formData.append('files'+i , this.files[i]);
                        }
                    }
                    const config = {
                        headers: { "Content-Type": "multipart/form-data" }
                    };
                    let url = this.baseURI + "/applications/" + uuid + "/upload";
                    GDCE_Client.requestApi("POST", url, formData, config).then( respone => {
                        if(respone.status){
                            this.$router.push({ name: 'ViewApplication', params: { uuid: uuid }}); 
                        }
                    }).catch(error => {
                        this.$store.state.loading.status = false;
                    });
                }else{
                    this.$router.push({ name: 'ViewApplication', params: { uuid: uuid }});
                }
            },
            showImage(src) {
                if(src.name.includes(this.declaration.uuid)){
                    window.open(this.imageBaseUrl + 'attachment?path=' + src.name);
                }else{
                    window.open(URL.createObjectURL(src));
                }
            },
            days() {
                if(this.declaration.lodgement_office_date && this.declaration.destination_office_date)
                {
                    let entry_date   = moment(this.declaration.lodgement_office_date);
                    let exit_date    = moment(this.declaration.destination_office_date);
                    let inbound_stay = (exit_date.diff(entry_date, 'days') + 1);
                    if(!isNaN(inbound_stay)) {
                        this.declaration.owner.inbound_stay = inbound_stay;
                    }
                }else{
                    this.declaration.owner.inbound_stay = null;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .adminlte-skin-ecustoms input:disabled{
        background-color: #DCE0E5 !important;
    }
    h3.custom-card-title svg{
        font-size: 22px !important;
    }
    .custom-card-title{
        color: #205670;
        text-transform: none !important;
    }

    label.required {
        &::after {
             content: " *";
             color: red;
         }
    }
</style>